import { z } from 'zod';

const booleanish = z
  .union([z.boolean(), z.literal('true'), z.literal('false')])
  .transform((value) => value === true || value === 'true')
  .optional()
  .catch(undefined);

const optionalString = z.string().optional().catch(undefined);

export const editorSearchSchema = z.object({
  taggingMode: booleanish,
  taggingSubMode: z.enum(['tag', 'mark-coverage']).optional().catch(undefined),
  translation: optionalString,
  revisionL: optionalString,
  revisionR: optionalString,
  revision: optionalString,
  sectionRevision: optionalString,
  useDraft: booleanish,
  embedd: booleanish,
  goToTagId: optionalString,
  goToTagOnId: optionalString,
  goToCommentId: optionalString,
});

export const pdfSearchSchema = z.object({
  useDraft: booleanish,
  pageBorders: booleanish,
  locale: optionalString,
});

export const documentSearchSchema = z.object({
  revision: optionalString,
});

export const taggingSearchSchema = z.object({
  tagFilter: z.object({ type: z.string(), value: z.string(), label: z.string() }).optional().catch(undefined),
});

export type TaggingSearch = z.infer<typeof taggingSearchSchema>;
export type EditorSearch = z.infer<typeof editorSearchSchema>;
export type PdfSearch = z.infer<typeof pdfSearchSchema>;
export type DocumentSearch = z.infer<typeof documentSearchSchema>;
